import { acquiredProperty } from "./acquired-property";
import { PropertyGroup } from "../property-group";

export const acquiredGroup = new PropertyGroup("Acquired", [acquiredProperty])
